export enum EReviewsStatus {
    APPROVE = 'Approve',
    PENDING = 'Pending',
}
